import { useContext } from "react";

import { PharmacyContext } from "./PharmacyContext";

export const usePharmacyContext = () => {
  const context = useContext(PharmacyContext);
  if (context === undefined || context === null) {
    throw new Error("usePharmacyContext must be used within a PharmacyProvider");
  }
  return context;
};
